import AddButton from "components/buttons/addbutton";
import ListButtons from "components/buttons/listButtons";
import ListHeadingComponent from "components/headingComponent/listHeading";
import {
  and,
  collection,
  deleteDoc,
  doc,
  endBefore,
  getDocs,
  limit,
  limitToLast,
  or,
  orderBy,
  query,
  startAfter,
  Timestamp,
  where,
} from "firebase/firestore";
import { dbFirestore } from "helper/config/firebase";
import Constant from "helper/constant/constant";
import CommonHeadings from "helper/constant/headings";
import Dateformat from "helper/constant/timeFormat";
import RoutingPaths from "helper/routingPath";
import TableName from "helper/tableName/tableName";
import ToastMessages from "helper/toastMessages";
import moment from "moment";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import React, { useEffect, useLayoutEffect } from "react";
import { useState } from "react";
import { ButtonGroup } from "react-bootstrap";
import Moment from "react-moment";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";

const PTEStudentsList = () => {
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [pteStudentsData, setPteStudentsData] = useState([]); // we fetch the data from the backend and shown in the form of list
  const [pteStudentsExportData, setPteStudentsExportData] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [filteredDates, setFilteredDates] = useState(null);
  const [page, setPage] = useState(0);
  const [isNext, setIsNext] = useState(false);
  const navigate = useNavigate();

  // MARK: use Effect function
  useEffect(() => {
    fetchPteStudentsApi();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  //  use layout effect function
  useLayoutEffect(() => {
    document.title = CommonHeadings.pteStudentListHeading;
  }, []);

  // MARK: function using in input
  const tapOnDateInput = (e) => {
    setFilteredDates(e.value);
  };

  // MARK: tap on button
  //  Edit data function
  const tapOnEdit = (pteStudentsData) => () => {
    navigate(RoutingPaths.editPteStudents, { state: pteStudentsData });
  };

  //  Delete data function
  const tapOnDeleteConfirm = (pteStudentsData) => () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to delete this pte student data`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "var(--delete-button-color)",
      cancelButtonColor: "var(--cancel-button-list)",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.value) {
        deleteDemoStudentsApi(pteStudentsData);
      }
    });
  };

  // MARK: API
  // fetch pte students API
  async function fetchPteStudentsApi() {
    let q = query(
      collection(dbFirestore, TableName.pteStudents),
      orderBy("created_at", "desc"),
      limit(Constant.perPage)
    );

    const querySnapshot = await getDocs(q);
    setPteStudentsData(
      querySnapshot.docs.map((docs) => ({ ...docs.data(), id: docs.id }))
    );
    setPage(0);
    setLoading(false);
    setIsNext(querySnapshot.docs.length < Constant.perPage ? true : false);
  }

  async function fetchPteStudentsExportApi() {
    let q = query(
      collection(dbFirestore, TableName.pteStudents),
      orderBy("created_at", "desc"),
    );

    const querySnapshot = await getDocs(q);
    setPteStudentsExportData(
      querySnapshot.docs.map((docs) => ({ ...docs.data(), id: docs.id }))
    );
  }

  async function createQueryForExport() {
    const filterText = filteredDates;
    if (filterText) {
      let q = query(
        collection(dbFirestore, TableName.pteStudents),
        where("created_at", ">=", getFilteredDatesTimeStamp().startTime),
        where("created_at", "<=", getFilteredDatesTimeStamp().endTime),
        limit(Constant.perPage), orderBy("created_at", "desc")
      );

      const querySnapshot = await getDocs(q);
      return querySnapshot;
    } else {
      let q = query(
        collection(dbFirestore, TableName.pteStudents),
        orderBy("created_at", "desc"),
      );
      const querySnapshot = await getDocs(q);
      return querySnapshot;
    }
  }



  // delete API
  const deleteDemoStudentsApi = async (pteStudents) => {
    await deleteDoc(doc(dbFirestore, TableName.pteStudents, pteStudents.id));
    setPteStudentsData((prevState) =>
      prevState.filter((el) => el.id !== pteStudents.id)
    );
    toast.success(ToastMessages.pteStudentsDelete);
  };

  // serach api
  const searchPteStudentsApi = async (e) => {
    const searchText = e.target.value.toLowerCase();
    setGlobalFilterValue(searchText);

    if (searchText) {
      let q = query(
        collection(dbFirestore, TableName.pteStudents),
        or(
          and(
            where("pte_student_name", ">=", searchText),
            where("pte_student_name", "<=", searchText + "\uf8ff")
          ),
          and(
            where(
              "pte_student_name",
              ">=",
              searchText.charAt(0).toUpperCase() + searchText.slice(1)
            ),
            where(
              "pte_student_name",
              "<=",
              searchText.charAt(0).toUpperCase() +
              searchText.slice(1) +
              "\uf8ff"
            )
          ),
          and(
            where(
              "pte_student_name",
              ">=",
              searchText.charAt(0).toLowerCase() + searchText.slice(1)
            ),
            where(
              "pte_student_name",
              "<=",
              searchText.charAt(0).toLowerCase() +
              searchText.slice(1) +
              "\uf8ff"
            )
          )
        )
      );
      const querySnapshot = await getDocs(q);

      setPteStudentsData(
        querySnapshot.docs.map((docs) => ({ ...docs.data(), id: docs.id }))
      );
    } else {
      fetchPteStudentsApi();
    }
  };

  // MARK: pagination code
  const showNext = ({ item }) => {
    const fetchNextData = async () => {
      var paginationQuery;

      paginationQuery = query(
        collection(dbFirestore, TableName.pteStudents),
        orderBy("created_at", "desc"),
        limit(Constant.perPage),
        startAfter(item.created_at)
      );

      const querySnapshot = await getDocs(paginationQuery);

      setPteStudentsData(
        querySnapshot.docs.map((docs) => ({ ...docs.data(), id: docs.id }))
      );
      setPage(page + 1);
      setIsNext(querySnapshot.docs.length < Constant.perPage ? true : false);
    };

    if (pteStudentsData.length === 0) {
      alert(ToastMessages.alertMessage);
    } else {
      fetchNextData();
    }
  };

  //  previous data function using pagination previous button
  const fetchPreviousData = async () => {
    setPage(page - 1);

    var paginationQuery;
    paginationQuery = query(
      collection(dbFirestore, TableName.pteStudents),
      orderBy("created_at", "desc"),
      endBefore(pteStudentsData[0].created_at),
      limitToLast(Constant.perPage)
    );

    const querySnapshot = await getDocs(paginationQuery);

    setPteStudentsData(
      querySnapshot.docs.map((docs) => ({ ...docs.data(), id: docs.id }))
    );
    setPage(page - 1);
    setIsNext(querySnapshot.docs.length < Constant.perPage ? true : false);
  };

  // condition while selecting the previous button
  const showPrevious = () => {
    if (pteStudentsData.length === 0) {
      fetchPteStudentsApi();
    } else {
      fetchPreviousData();
    }
  };

  // MARK:  reset button function
  const tapOnResetButton = () => {
    setFilteredDates(null);
    fetchPteStudentsApi();
  };

  // MARK: filter dates
  function getFilteredDatesTimeStamp() {
    if (filteredDates) {
      const startDate = moment(filteredDates[0]).format(Dateformat.YYYYMMDD);
      const endDate = moment(filteredDates[1]).format(Dateformat.YYYYMMDD);

      const startTimestamp = Timestamp.fromDate(new Date(startDate)).toMillis();
      const endTimestamp = Timestamp.fromDate(new Date(endDate)).toMillis();
      return { startTime: startTimestamp, endTime: endTimestamp };
    }
    return null;
  }

  async function createQueryForTable() {
    const filterText = filteredDates;

    if (!filterText) {
      toast.error(ToastMessages.filterDate);
      <ToastContainer />
    }

    if (filterText) {
      let q = query(
        collection(dbFirestore, TableName.pteStudents),
        where("created_at", ">=", getFilteredDatesTimeStamp().startTime),
        where("created_at", "<=", getFilteredDatesTimeStamp().endTime),
        limit(Constant.perPage), orderBy("created_at", "desc")
      );


      const querySnapshot = await getDocs(q);
      return querySnapshot;
    } else {
      let q = query(
        collection(dbFirestore, TableName.pteStudents),
        orderBy("created_at", "desc"),
        limit(Constant.perPage)
      );
      const querySnapshot = await getDocs(q);
      return querySnapshot;
    }
  }

  // MARK: filter function using in input
  const tapOnFilterButton = async () => {
    const querySnapshot = await createQueryForTable();
    const array = querySnapshot.docs.map((docs) => ({ ...docs.data() }));
    setPteStudentsData(array);
    setPteStudentsExportData(array)
    setIsNext(querySnapshot.docs.length < Constant.perPage ? true : false);
  };

  // MARK: modify student model in which we add new inputs in an array
  const modifyStudentModel = (doc) => {
    const data = doc.data();

    return {
      pte_id: data.pte_id,
      user_name: data.user_name,
      phone_number: data.phone_number,
      email: data.email,
      pte_student_name: data.pte_student_name,
      created_at: moment(data.created_at).format(
        Dateformat.YYYYMMDD
      ),

    };
  };

  // MARK: export data in the excel sheet
  const exportToExcel = () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to export these data.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "var(--delete-button-color)",
      cancelButtonColor: "var(--cancel-button-list)",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then(async (result) => {
      if (result.value) {
        const querySnapShot = await createQueryForExport();

        const mylist = querySnapShot.docs.map((model) =>
          modifyStudentModel(model)
        );

        const filterUserData = mylist.map(
          ({
            pte_id,
            pte_student_name,
            user_name,
            phone_number,
            email,
            created_at,
          }) => ({
            pte_id: pte_id,
            pte_student_name: pte_student_name,
            pte_user_name: user_name,
            conatct_number: phone_number,
            email: email,
            created_at: created_at,
          })
        );
        if (filteredDates) {
          const workBook = XLSX.utils.book_new();
          const workSheet = XLSX.utils.json_to_sheet(filterUserData);
          XLSX.utils.book_append_sheet(workBook, workSheet, "students");
          XLSX.writeFile(workBook, "pte_students_data.xlsx");
        } else {
          toast.error(ToastMessages.filterDate)
        }
      }
    });
  };

  //MARK:  UI
  //Search UI
  const searchBar = () => {
    return (
      <>
        <div className="search__main_div">
          <div style={{ flexGrow: "1" }}>
            <IconField iconPosition="left">
              <InputIcon className="pi pi-search" />
              <InputText
                type="search"
                value={globalFilterValue}
                onChange={searchPteStudentsApi}
                placeholder="Search by Name"
              />
            </IconField>
          </div>
          <div className="filter__button-section">
            <Calendar
              value={filteredDates}
              onChange={tapOnDateInput}
              selectionMode="range"
              readOnlyInput
              showIcon
              placeholder="Select start and end date"
            />

            <Button
              type="button"
              label="Filter"
              className="list__filter_button ms-2 me-2"
              onClick={tapOnFilterButton}
            />
            <Button
              type="button"
              label="Reset"
              className="list__reset_button"
              onClick={tapOnResetButton}
            />
          </div>
        </div>
      </>
    );
  };

  const header = searchBar();

  if (isLoading) {
    return <div className="loading-div"> Loading ... </div>;
  }

  // pte students columns data
  const pteStudentscolumns = [
    {
      field: "pte_id",
      header: "ID",
    },
    { field: "pte_student_name", header: "Name", className: "table__column__capital", },
    { field: "user_name", header: "User Name", className: "table__column__capital", },
    { field: "phone_number", header: "Contact Number" },
    { field: "email", header: "Email" },
    {
      field: "created_at",
      header: "Created At",
      CardBody: (data) => (
        <Moment format={Dateformat.DDMMYYYHHMMSS}>{data.created_at}</Moment>
      ),
    },
    {
      field: "actions",
      header: "Actions",
      CardBody: (data) => (
        <>
          <ListButtons
            editclick={tapOnEdit(data)}
            deleteclick={tapOnDeleteConfirm(data)}
          />
          <ToastContainer />
        </>
      ),
    },
  ];

  return (
    <div className="modules__main__div">
      <div className="col-12">
        <div className="card modules__card">
          <div className="modules__lists_main-content">
            <ListHeadingComponent
              classname="flex-grow-1"
              headingName={CommonHeadings.pteStudentListHeading}
            />
            <Button
              label="Export Data"
              type="button"
              onClick={exportToExcel}
              className="list__export_button me-2"
            />
            <AddButton navigation={RoutingPaths.addPteStudents} />
          </div>

          <DataTable
            className="mt-5 mb-3 table-container"
            value={pteStudentsData}
            header={header}
            emptyMessage="No data found."
          >
            {pteStudentscolumns.map((col) => (
              <Column
                key={col.field}
                field={col.field}
                header={col.header}
                bodyClassName={col.className}
                body={col.CardBody}
              />
            ))}
          </DataTable>
          <ButtonGroup
            style={{ gap: "1rem", alignSelf: "center" }}
            className="mt-5"
          >
            {
              <button
                disabled={page === 0 ? true : false}
                onClick={() => showPrevious()}
                className={
                  page === 0 ? "previous-disabled-button" : "previous-button"
                }
              >
                <span className="pi pi-angle-left">Previous</span>
              </button>
            }

            {
              <button
                disabled={isNext}
                onClick={() =>
                  showNext({ item: pteStudentsData[pteStudentsData.length - 1] })
                }
                className={
                  isNext ? "previous-disabled-button" : "previous-button"
                }
              >
                Next<span className="pi pi-angle-right"></span>
              </button>
            }
          </ButtonGroup>
        </div>
      </div>
    </div>
  );
};

export default PTEStudentsList;
